const react_app_backend_url = process.env.REACT_APP_BACKEND_URL;

export {react_app_backend_url}
